<div class="its-plans__element-progress" class:complete>
    <span class="screen-reader">{complete ? i18n.completed : i18n.notCompleted}</span>
</div>

<script>
    export let complete;
    export let i18n;
</script>
